@if (shouldShowChanged$ | async) {
  <div class="overlay">
    <mat-progress-spinner class="spinner" [color]="color" [mode]="mode"></mat-progress-spinner>
  </div>
}
